import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_barbatrader.png",
      alt: "Estratégias Barba Trader",
    },
    title: "Alavanque seus lucros com o Barba Trader",

    // String ou array de strings
    text: "Você está cansado de perder tempo e dinheiro tentando achar a estratégia perfeita para operar no Mercado Financeiro? O Barba Trader tem a solução para você. Nossas estratégias automatizadas são resultado de anos de experiência de um day trader de sucesso, combinado com a mais alta tecnologia disponível. Com elas, você pode aproveitar ao máximo as oportunidades do mercado, sem precisar passar horas na frente do computador.",
    testimonial: {
      text: "A automação de estratégias é a chave para operar de forma eficiente no Mercado Financeiro. Com o uso de tecnologia de ponta, é possível maximizar os resultados e minimizar os riscos.",
      author: {
        name: "Barba Trader",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias do Barba Trader",
    heading: "Unimos a experiência de mercado com a tecnologia",
    subtitle:
      "Estratégias operacionais validadas por centenas de traders profissionais, com desempenho comprovado em milhares de operações. Tudo pronto para você aproveitar, com poucos cliques!",
  },

  cta: {
    title: "Quer aumentar seus lucros?",
    subtitle: "Experimente agora as estratégias automatizadas do Barba Trader.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Barba Trader",
    col1: [
      "Com mais de 10 anos de experiência na área, sendo os últimos 4 anos de acompanhamento de perto do dia a dia de mais de 140 traders, acumulamos  insights valiosos sobre as principais dificuldades enfrentadas pelos investidores, especialmente pelos iniciantes.",
      "Com esse conhecimento em mãos, o Barba Trader vem trabalhando continuamente no desenvolvimento de estratégias automatizadas que permitem superar essas dificuldades e obter resultados consistentes no mercado.",
    ],
    col2: [
      "A sua missão é ajudar investidores de todos os níveis a alcançar seus objetivos financeiros por meio de soluções tecnológicas inovadoras e eficientes.",
    ],
  },

  stats: {
    title: "Alguns números do Barba Trader",
    subtitle:
      "Mais de 6 anos no mercado financeiro e mais de 20 anos em tecnologia e gestão",
    data: [
      {
        value: "+6k",
        description: "Horas de mentoria em salas fechadas",
      },
      {
        value: "+5k",
        description: "Operações registradas e analisadas",
      },
      {
        value: "+4k",
        description: "Pontos acumulados (WDO) nos últimos 18 meses",
      },
    ],
  },

  features: {
    title: "Por que utilizar os nossos robôs?",
    subtitle: "Veja quais as principais vantagens dos robôs Barba Trader.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Você pode testar nossas estratégias e comprovar a performance em sua conta",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Estamos continuamente buscando os melhores parâmetros e Gestão de Risco para você não se preocupar com isso.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte",
        description:
          "Prezamos pela qualidade e eficiência ao esclarecer todas as suas dúvidas sobre nossas estratégias",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Suas operações executadas sem atraso, com estratégias programadas com lógica voltada à eficiência",
      },
      {
        icon: iconsSet.clock,
        title: "Liberdade",
        description:
          "Você, livre para aproveitar o seu dia enquanto as nossas estratégias encontram e realizam as melhores operações do mercado",
      },
      {
        icon: iconsSet.favorite,
        title: "Objetividade",
        description:
          "Os impulsos emocionais não serão mais um problema para seu operacional. Nossas estratégias utilizam sinais de indicadores confiáveis e eficientes para realizar as operações",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "75% da meta mensal atingida em 5 dias de operação em maio/23 utilizando as estratégias automatizadas do Barba Trader. Resultados positivos e consistentes são contínuos eliminando pela automação o stress operacional e até emocional. Parabéns ao excelente trabalho desenvolvido.",
      author: "Antonio Dirceu Baldo",
      job: "Analista de Sistemas",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Com as estratégias do Barba Trader, tenho a consistência diária, e a facilidade de um operacional robusto, desta forma estou atingindo o objetivo a cada dia, e com atendimento personalizado que ajuda nas dúvidas. Por isso recomendo.",
      author: "Ed Silva",
      job: "Analista de Sistemas",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Barba Trader",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
